module.exports = __webpack_public_path__ + "img/wrong.8be5119a.svg";